<template>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <v-progress-linear :value="progressValue" height="10" info></v-progress-linear>
      <v-card v-if="!transitioning && !currentConflict.remainingProblems">
        <v-card-title>
          Great. We have no open Conflicts!
        </v-card-title>
      </v-card>
      <transition name="fade">
        <v-card v-if="currentConflict.remainingProblems && !transitioning">
          <v-card-title>
            {{currentConflict.description}}
          </v-card-title>
          <v-card-text>
            <v-expansion-panel>
              <v-expansion-panel-content v-for="(solution, index) in currentConflict.possibleSolutions" :key="index" v-bind:value="index === 0">
                <div slot="header" v-on:click="solutionClick(solution)">{{solution.title}}</div>
                <v-card>
                  <v-card-text class="grey darken-2">
                    <p>
                      {{solution.description}}
                    </p>
                    <v-select v-if="solution.choices.length" v-model="currentSolution.choice" :options="solution.choices" class="grey-lighten-3"></v-select>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <div class="action-buttons">
              <v-btn secondary v-on:click="skipConflict">Skip</v-btn>
              <v-btn
                :loading="currentConflict.loading"
                :disabled="currentConflict.loading" success v-on:click="solveConflict">Solve</v-btn>
            </div>
            <v-alert error dismissible v-model="hasErrors" transition="scale-transition">{{errorDescription}}</v-alert>
          </v-card-text>
        </v-card>
      </transition>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'conflicts',
  data () {
    return {
      totalNumberOfConflicts: 0,
      transitioning: false,
      hasErrors: false,
      errorDescription: '',
      currentConflict: {
        remainingProblems: 0
      },
      currentSolution: null,
      skippedConflicts: []
    }
  },
  methods: {
    solutionClick: function (solution) {
      this.currentSolution = solution
      this.hasErrors = false
    },
    solveConflict: function () {
      this.hasErrors = false
      this.currentConflict.loading = true
      if ((this.currentSolution.choices && this.currentSolution.choices.length > 0) &&
          this.currentSolution.choice == null) {
        this.hasErrors = true
        this.errorDescription = 'You need to make a choice to solve this conflict!'
        this.currentConflict.loading = false
        return
      }
      var relatedEntityId = ''
      if (this.currentSolution.choice) {
        relatedEntityId = this.currentSolution.choice.relatedEntityId
      }
      this.$axios.post(
        process.env.API_URL + 'problems/solve/' + this.currentConflict.id,
        {
          callMethod: this.currentSolution.callMethod,
          relatedEntityId: relatedEntityId
        }).then(response => {
          this.currentConflict.loading = false
          this.getNextConflict()
        }).catch(error => {
          console.log(error)
          this.hasErrors = true
          this.errorDescription = 'There was a problem solving this conflict on the server-side!'
          this.currentConflict.loading = false
        })
    },
    skipConflict: function () {
      this.hasErrors = false
      this.skippedConflicts.push(this.currentConflict.id)
      this.getNextConflict()
    },

    getNextConflict: function () {
      this.transitioning = true

      var queryParams = ''

      if (this.skippedConflicts.length) {
        queryParams += '?skipped='
        for (var i = 0; i < this.skippedConflicts.length; i++) {
          if (i !== 0) {
            queryParams += ','
          }
          queryParams += this.skippedConflicts[i]
        }
      }

      return this.$axios.get(process.env.API_URL + 'problems/next' + queryParams)
        .then(response => {
          this.currentConflict = response.data
          // Parse data to be able to use in vue-select
          for (var j = 0; j < this.currentConflict.possibleSolutions.length; j++) {
            if (this.currentConflict.possibleSolutions[j].choices) {
              for (var k = 0; k < this.currentConflict.possibleSolutions[j].choices.length; k++) {
                var currentChoice = this.currentConflict.possibleSolutions[j].choices[k]
                currentChoice.label = currentChoice.value
              }
            }
          }

          if (this.skippedConflicts.length &&
            this.skippedConflicts[0] === this.currentConflict.id) {
            this.skippedConflicts.shift()
          }

          this.currentSolution = this.currentConflict.possibleSolutions[0]
          this.transitioning = false
        })
        .catch(e => {
          if (e.response) {
            if (e.response.status === 404) {
              this.transitioning = false
              this.currentConflict.remainingProblems = 0
            }
          } else {
            console.log(e)
          }
        })
    }
  },
  created () {
    this.$axios.get(process.env.API_URL + 'problems/count')
        .then(response => {
          this.totalNumberOfConflicts = response.data
        })
        .catch(e => {
          console.log(e)
        })
    this.getNextConflict()
  },
  computed: {
    progressValue: function () {
      if (this.totalNumberOfConflicts === 0) return 100
      return (100 / this.totalNumberOfConflicts) * (this.totalNumberOfConflicts - this.currentConflict.remainingProblems)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.grey-lighten-3 .dropdown-toggle {
  background-color: #eee!important;
}
</style>
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.action-buttons {
  margin-top: 10px;
}

.btn {
  cursor: pointer;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// Conflicts.vue?0e4951aa